import { array, object, string } from "yup"
import { useValidatorSeeker } from "@ui-seeker/app"

import { userSettingsWebSupplierGroupFormData } from "../@signals"


const schema = object({
	name: string().required('Name is required'),
	web_suppliers: array().min(1, 'At least one web supplier is required'),
})

export default function useUserSettingsWebSupplierGroupValidator() {
	const { isValid, errors } = useValidatorSeeker(userSettingsWebSupplierGroupFormData.value, schema)

	return {
		isValid,
		nameError: errors.name || null,
		webSuppliersError: errors.web_suppliers || null,
	}
}